export default [
  {
    path: "/menu",
    name: "Menu",
    component: () => import("@/page/menu/Menu.vue"),
  },
];
